import removeAfterEffectsAsset from './v1_0_0/v1_0_0_migration';
import { Migration } from './types';

export default [removeAfterEffectsAsset] satisfies Migration<any, any>[];
